<template>
  <sq-loadmore :top-method="topMethod">
    <sq-timeline>
      <sq-timeline-item v-for="(item, i) in data" :key="item.CommentID">
        <div
          slot="yeartime"
          class="m-timeline-time--year fz11"
          v-if="showDate(i, 'year')"
        >
          {{formateDate(item.CreateTimeToInt, 'year')}}
        </div>
        <div
          :class="{
            'm-timeline-item': true,
            'm-timeline-item--head': showDate(i, 'year'),
            'm-timeline-item--notime': !showDate(i, 'date'),
            'm-timeline-item--tail': i === data.length - 1 ? true : showDate(i+1, 'year'),
            'm-timeline-item--last': i === data.length -1
          }"
        >
          <div
            class="m-timeline-time--day fz12"
            v-if="showDate(i, 'date')"
          >
            {{formateDate(item.CreateTimeToInt, 'date')}}
          </div>
          <sq-card :data="item" :show-date="showDate(i, 'date')">
            <sq-card-incard
              :data="item.PreCommentInfo"
              v-if="item.PreCommentInfo"
              :isInCard="true"
            ></sq-card-incard>
          </sq-card>
        </div>
      </sq-timeline-item>
    </sq-timeline>
    <slot></slot>
  </sq-loadmore>
</template>

<script>
import Timeline from '../timeline/timeline'
import TimelineItem from '../timeline/timelineItem'
import Card from '../card/card'
import InCard from '../card/incard'
import Loadmore from './loadmore'
export default {
  components: {
    'sq-timeline': Timeline,
    'sq-timeline-item': TimelineItem,
    'sq-card': Card,
    'sq-card-incard': InCard,
    'sq-loadmore': Loadmore
  },

  props: {
    data: {
      type: Array
    },
    topFunc: {
      type: Function
    }
  },

  methods: {
    topMethod (callback) {
      this.topFunc(callback)
    },
    showDate (i, type) {
      if (i === 0) {
        return true
      }
      var cur = new Date(this.data[i].CreateTimeToInt * 1000)
      var prev = new Date(this.data[i - 1].CreateTimeToInt * 1000)
      if (cur.getFullYear() === prev.getFullYear() && cur.getMonth() === prev.getMonth() && cur.getDate() === prev.getDate() && type === 'year') {
        return false
      }

      if (cur.getHours() === prev.getHours() && cur.getMinutes() === prev.getMinutes() && type === 'date') {
        return false
      }
      return true
    },
    formateDate (timestamp, type) {
      var time = new Date(timestamp * 1000)
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var date = time.getDate()
      var hh = time.getHours()
      var mm = time.getMinutes()
      hh = hh <= 9 ? '0' + hh : hh
      mm = mm <= 9 ? '0' + mm : mm
      if (type === 'year') {
        return [year, month, date].join('-')
      }
      if (type === 'date') {
        return [hh, mm].join(':')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// live.vue?717711f6